<template>
  <v-container class="contenedor">
        <!-- INFORMACION TOOLBAR  -->
        <v-card elevation="4" class="mb-5">
            <v-toolbar flat elevation="4">
                <v-card class="icon">
                    <v-icon
                        style="margin-left: 30px; margin-top: 25px"
                        color="white"
                        x-large=""
                        >mdi-fingerprint</v-icon
                    >
                </v-card>
            <div class="usuario">REGISTRAR BIOMETRIA DE VENDEDOR</div>
           
            </v-toolbar>
        </v-card>
        <br />

        <v-col>
            <v-tabs
                v-model="generalTab"
                background-color="#FFFF"
                centered
                style="white"
                dark
                grow=""
                icons-and-text
            >
            <v-tabs-slider></v-tabs-slider>

            <v-tab v-for="(item, i) in itemTabs" :key="i">
                {{ item.title }}
                <v-icon>{{ item.icon }}</v-icon>
            </v-tab>

            <v-tab-item v-model="generalTab">
                <v-data-table
                    :headers="headers"
                    :items="informacionCartera"
                    :search="search"
                    class="elevation-3"
                >
                <template v-slot:no-data>
                    <v-alert
                    :value="true"
                    color="gray"
                    icon="mdi-sync-alert"
                    outlined
                    >No hay información para mostrar</v-alert
                    >
                </template>
                </v-data-table>
            </v-tab-item>
            </v-tabs>
        </v-col>
    <v-overlay :value="sisi">
      <div class="loader"></div>
    </v-overlay>
        
    <div>
      
      <input type="number" v-model.number="cedula" @keyup.enter="consultarCedula" placeholder="Ingrese la cédula">
      <button @click="consultarCedula" class="button">Consultar</button>
      <div v-if="mostrarDatos">
        <p class="mensaje">Nombre: {{ nombreUsuario }}</p>
        <p v-if="!tieneHuella" class="mensaje-error">El vendedor no tiene huella enrolada</p>
        <p v-if="tieneHuella" class="mensaje">El vendedor ya tiene huella enrolada - Si necesita volver a enrolar, solicitar a sistemas desenrolar</p>
        <button 
          v-if="!tieneHuella" 
          @click="capturarHuella" 
          class="button"
        >
          Capturar Huella
        </button>
      </div>
      <p v-if="errorConsulta" class="mensaje-error">{{ errorConsulta }}</p>
      <p v-if="huellaGuardada" class="mensaje">{{ mensajeHuella }}</p>
      <div v-if="mensaje" class="mensaje">{{ mensaje }}</div>
      <div v-if="mensajeError" class="mensaje-error">{{ mensajeError }}</div>
    </div>
 
    </v-container>


    
</template>

<script>
import axios from 'axios';
import env from "../../env";

export default {
  data() {
    return {
      sisi: false,
      cedula: '',
      mostrarDatos: false,
      nombreUsuario: '',
      tieneHuella: false,
      errorConsulta: '',
      huellaGuardada: false,
      mensajeError: '',
      mensajeHuella: ''
    };
  },
  methods: {
    consultarCedula() {
      this.sisi = true,
      this.mensajeHuella = '';
      axios.get(`${env.endpoint}VisitasNew/ConsultarCedula?cedula=${this.cedula}`)
        .then(response => {
          if (response.data.error) {
            this.nombreUsuario = '';
            this.mensajeError = '';
            this.sisi = false;
            this.tieneHuella = false;
            this.errorConsulta = response.data.error;
            this.mostrarDatos = false; // Ocultar los datos si la cédula no se encuentra
          } else {
            this.sisi = false;
            this.nombreUsuario = response.data.nombre;
            this.tieneHuella = response.data.tieneHuella;
            this.mensajeError = '';
            this.mostrarDatos = true;
            this.errorConsulta = ''; // Limpiar el mensaje de error
          }
        })
        .catch(error => {
          this.sisi = false;
          console.error('Error al consultar la cédula:', error);
          this.errorConsulta = 'Error al consultar la cédula';
        });
    },
    capturarHuella() {
      this.sisi = true;
      this.mensajeHuella = '';
      this.mensajeError = '';
  fetch('http://127.0.0.1:9494/biometrico/')
    .then(response => {
      if (!response.ok) {
        this.sisi = false;
        return response.json().then(data => {
          throw new Error(data.error || 'Error en la comunicación con el lector de huellas.');
        });
      }
      return response.text();
    })
    .then(data => {
      const partes = data.split('|');
      if (partes.length >= 2) {        
        const captura = partes[1];
        this.enviarHuella(captura, `captura_${this.cedula}.bin`);
        this.sisi = false;
      } else {
        console.error('No se encontró el texto entre "|"');
        this.mensajeHuella = 'Error al capturar la huella biométrica';
        this.sisi = false;
      }
    })
    .catch(error => {
      this.sisi = false;
      console.error('Error al capturar la huella biométrica:', error.message);
      this.mensajeError = error.message;
    });
},

    enviarHuella(huella, nombreArchivo) {
      const formData = new FormData();
      formData.append('cedula', this.cedula);
      formData.append('huella', new Blob([huella], { type: 'application/octet-stream' }), nombreArchivo);
      console.log(this.cedula);
      axios.post(`${env.endpoint}VisitasNew/GuardarHuella`, formData)
        .then(response => {
          console.log('Respuesta del servidor:', response.data);
          this.huellaGuardada = true;
          this.mensajeHuella = 'Huella biométrica guardada exitosamente';
          this.mensajeError = '';
        })
        .catch(error => {
          console.error('Error al enviar la huella biométrica:', error);
          this.mensajeHuella = 'Error al enviar la huella biométrica';
        });
    }
  }
}
</script>

<style>

.button {
  background-color: #215f7e;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
.mensaje {
  margin-top: 10px;
  padding: 10px;
  background-color: #f2f2f2;
  border: 1px solid #ccc;
  color: #070a36
}

.mensaje-error {
  margin-top: 10px;
  padding: 10px;
  background-color: #ffcccc;
  border: 1px solid #ff0000;
  color: #070a36
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
.contenedor-ppalB {
  display: flex;
  justify-content: center; /* Centrar horizontalmente */
  align-items: center; /* Centrar verticalmente */
  height: 50vh; /* Ajustar altura al 100% del viewport */
  margin: 20px;
  border: 2px solid #070a36;
}

.content {
  text-align: center; /* Alinear contenido al centro */
}




</style>
